export default function Node_Intro() {
  return <div>Node_Intro Component</div>;
}
